import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Stepper, Step, StepLabel } from '@mui/material';

type ParamsStyle = {
   theme?: Theme;
}

export const ContentForm = styled.div(
   ({ theme }: ParamsStyle) => `
   width: 100%;
   display: flex;
   text-align: center;
   border-radius: 10px;
   align-items: center;
   flex-direction: column;
   
   border: none;
   margin: 0 auto;
   padding: 2.375rem 1rem;

   button {
      width: 100%;
      margin-top: .6875rem;
   }
   
   @media(min-width: ${theme?.breakpoints.values.md}px) {
      width: 25rem;
      padding: 2.375rem 1.6875rem;
      border: 1.5px solid rgba(12, 28, 51, 0.5);
   }
`);

export const StepperCustom = styled(Stepper)(
   ({ theme }: ParamsStyle) => `
   width: 100%;
   max-width: 27rem;
   align-items: center;

   @media(min-width: ${theme?.breakpoints.values.md}px) {
      margin-left: 0px;
   }
`);

export const StepMui = styled(Step)(
   ({ theme }: ParamsStyle) => `
   width: 100%;

   .MuiStepConnector-root.MuiStepConnector-horizontal.MuiStepConnector-alternativeLabel {
       position: absolute;
       top: 0;
       bottom: 0;
       z-index: 1;
       width: 70%;
       height: 2.5px;
       margin: auto;
       left: calc(-50% + 1rem);
       right: calc(50% + 1rem);
       background-color: #8D9BB5;
   }

   .css-14qqfdt-MuiStepConnector-line {
       border: none;
   }

   &.Mui-completed {
       .MuiStepLabel-alternativeLabel {
           .MuiStepLabel-iconContainer {
               border: 2px solid #CBE49E;
           }
       }
   }

   @media(min-width: ${theme?.breakpoints.values.md}px) {
       width: 7.5rem;
   }
`);

export const StepLabelMui = styled(StepLabel)(
   ({ theme }: ParamsStyle) => `
   .MuiStepLabel-labelContainer {
       display: flex;
       align-items: center;
       justify-content: center;
   }

   .MuiStepLabel-alternativeLabel {
       color: ${theme?.palette.grey[400]};
       margin-top: 9px !important;
       font-weight: 600;
       z-index: 2;

       &.Mui-completed {
           color: ${theme?.palette.secondary.main};
       }

       &.MuiStepLabel-iconContainer {
           border: 2px solid ${theme?.palette.grey[400]};
           border-radius: 100px;
       }

       &.Mui-active {
           &.MuiStepLabel-label {
               margin-top: 0px !important;
               color: ${theme?.palette.primary.main};;
               padding: 0 3px;
               font-weight: 600;
               border-bottom: 2px solid ${theme?.palette.secondary.main};
           }
       }
   }

   .MuiSvgIcon-root {
       color: ${theme?.palette.grey[400]};
       width: 24px;
       height: 24px;

       text {
           fill: #fff;
       }

       &.Mui-active {
           color: #fff;
           width: 30px;
           height: 30px;
           border-radius: 100px;
           border: 1.6px solid #1C386B;

           .MuiStepIcon-text {
               fill: ${theme?.palette.primary.main};
               color: ${theme?.palette.primary.main};
           }
       }

       &.Mui-completed {
           fill: ${theme?.palette.secondary.main};
       }

       @media(min-width: ${theme?.breakpoints.values.md}px) {
           width: 24px;
           height: 24px;
           
           &.Mui-active {
               width: 35px;
               height: 35px;
           }
       }
   }
              
   .MuiStepIcon-text {
       fill: ${theme?.palette.grey[400]};
       color: ${theme?.palette.grey[400]};
   }

   .css-zpcwqm-MuiStepConnector-root {
       .css-14qqfdt-MuiStepConnector-line {
           border-top-width: 5px;
       }
   }
`);